import { AxiosInstanceFunc, HZAxiosInstanceFunc } from '@hz-insights/web-components'

export type ChartLang = 'zh' | 'en'

// 生产环境 Router 带 basename(如 /v2), window.location.pathname 会带上该前缀,
// 语言判断前必须先剥离, 否则线上永远判成中文(本地 basename 为空所以表现为仅线上复现)
const BASE_NAME = process.env.REACT_APP_BASE_NAME || ''
const stripBaseName = (pathname: string): string =>
  BASE_NAME && pathname.startsWith(BASE_NAME + '/') ? pathname.slice(BASE_NAME.length) : pathname

// 从当前路径判断图表语言: /charts/en/:id 或 /charts/display/en/:id 为英文图表
export const getChartLangFromPath = (pathname: string): ChartLang => {
  const path = stripBaseName(pathname)
  if (/^\/charts\/en\/\d+/.test(path)) return 'en'
  if (/^\/charts\/display\/en\/\d+/.test(path)) return 'en'
  return 'zh'
}

// 中英文图表 URL 互换: /charts/8286 <-> /charts/en/8286, /charts/display/8286 <-> /charts/display/en/8286
export const toggleChartLangUrl = (pathname: string, lang: ChartLang): string => {
  const path = stripBaseName(pathname)
  if (lang === 'en') {
    if (/^\/charts\/display\/\d+/.test(path))
      return BASE_NAME + path.replace(/^\/charts\/display\//, '/charts/display/en/')
    if (/^\/charts\/\d+/.test(path)) return BASE_NAME + path.replace(/^\/charts\//, '/charts/en/')
    return pathname
  }
  return BASE_NAME + path.replace(/^\/charts\/display\/en\//, '/charts/display/').replace(/^\/charts\/en\//, '/charts/')
}

// 安装请求拦截器: 处于英文图表页时, 自动给图表相关请求注入 lang=en
// 组件库存在两个 axios 实例: 应用侧服务走 AxiosInstanceFunc, 组件库 Chart(info/data) 走 HZAxiosInstanceFunc, 都需覆盖
export const installChartLangInterceptor = () => {
  const injectLang = (config: any) => {
    const url = config.url || ''
    if (getChartLangFromPath(window.location.pathname) !== 'en') return config
    // 图表 info / data 请求注入 lang
    if (/^\/charts\/\d+(\?|$)/.test(url) && (!config.method || config.method.toLowerCase() === 'get')) {
      config.params = { ...(config.params || {}), lang: 'en' }
    }
    if (/^\/charts\/\d+\/data/.test(url) && config.method?.toLowerCase() === 'post') {
      if (config.data && typeof config.data === 'object') {
        config.data = { ...config.data, lang: 'en' }
      } else if (typeof config.data === 'string') {
        try {
          config.data = JSON.stringify({ ...JSON.parse(config.data), lang: 'en' })
        } catch (e) {
          // data 非 JSON 字符串时不注入
        }
      }
    }
    return config
  }
  AxiosInstanceFunc.interceptors.request.use(injectLang)
  HZAxiosInstanceFunc.interceptors.request.use(injectLang)
}
